<template>
  <BlockContainer v-if="account" class="p-4 mt-2" @click.native="$emit('click.edit')">
    <div v-if="account.useCount == 0" class="text-right" @click.stop="$emit('click:delete')">
      <i class="budicon-trash"></i>
    </div>

    <div class="text-center">
      <div class="bank-logo mb-4">
        <img v-if="account.bank.logo" class="img-fluid" :src="account.bank.logo" />
        <i v-else class="budicon-wallet"></i>
      </div>

      <p class="m-0">Bankkonto</p>
      <h4>{{ account.bankAccount | formatBankAccount }}</h4>

      <div class="mt-4 pt-2">
        <p class="m-0">{{ account.alias }}</p>
        <p class="m-0">{{ account.bank.name }}</p>
        <div v-if="account.useCount != null">
          <p v-if="account.useCount == 1" class="m-0 text-muted">Brukt i ett aktivt leieforhold.</p>
          <p v-else-if="account.useCount > 0" class="m-0 text-muted">
            Brukt i {{ account.useCount }} aktive leieforhold.
          </p>
          <p v-else class="m-0 text-muted">Ikke brukt i noe leieforhold.</p>
        </div>
      </div>
    </div>
  </BlockContainer>
</template>

<script>
import BlockContainer from '@/components/BlockContainer';
export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
  },

  components: {
    BlockContainer,
  },
};
</script>

<style scoped lang="scss">
.bank-logo {
  width: 60px;
  height: 60px;
  margin: auto;
  border: 1px solid $gray-300;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 50%;
  }

  i {
    font-size: 1.4rem;
  }
}
</style>
